import { errorAlertApp } from "./alert_app";

export const authCheck = (user) => {
    if (user.is_authenticated == 0) {
        errorAlertApp({response:{data:{location:'login',message:'ログインしてください。'}}});
    }
}

export const screenTransition = (menuName) => {
    window.postMessage({
        'callType': 'menu',
        'menuName': menuName
    }, '*');
}

export const callBarcode = (screenName,recordId=0,staffId=0,patientName='',hospitalName='') => {
    window.postMessage({
        'callType': 'barcode',
        'screenName': screenName,
        'recordId':recordId,
        'staffId':staffId,
        'patientName':patientName,
        'hospitalName':hospitalName
    }, '*');
}

export const callSound = (type) => {
    window.postMessage({
        'callType': 'sound',
        'soundType': type
        }, '*');
}

export const callBarcodeReaderSetting = (params) => {
    window.postMessage({
        'callType': 'barcode_reader_setting',
        'barcode_window_width': params.barcode_window_width,
        'barcode_window_height': params.barcode_window_height,
        'barcode_scan_multi': params.barcode_scan_multi
        }, '*');
}
